import React, { useEffect, useRef, useState } from "react";
import "../Style/web.css";


import ServicesSection from "../components/Webservice";
import SoftwareSection from "../components/Websoftware";
import ProcessSection from "../components/Webprocess";
import FutureSection from "../components/Webfuture";
import StackSection from "../components/Webstack";
import PlatformSection from "../components/Webplatforms";
import FormSection from "../components/Forms";
import DoubtsSection from "../components/Webdoubts";
import ClientSection from "../components/Clientfeedback";
import Pagefooter from "../components/Footer";


function WebPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="web-page">
        {/* CSS-only pattern layers, no images */}
        <div className="web-grid-pattern" aria-hidden="true" />
        <div className="web-blob web-blob-1" aria-hidden="true" />
        <div className="web-blob web-blob-2" aria-hidden="true" />
        <div className="web-blob web-blob-3" aria-hidden="true" />

        <div
          className={`web-overlay ${isVisible ? "web-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="web-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="web-logo web-anim web-anim-1"
            /> */}

            <span className="web-eyebrow web-anim web-anim-2">
              Website Development Services
            </span>

            <h1 className="web-title web-anim web-anim-3">
              Custom Website Development Services That Drive Business Growth
            </h1>

            <p className="web-description web-anim web-anim-4">
              Build fast, secure, and scalable websites tailored to your business goals. At MPeoples, we create SEO-friendly, mobile-responsive, and conversion-focused websites that deliver exceptional user experiences and measurable business results.
            </p>

            <a href="tel:+919876543210" className="web-btn web-anim web-anim-5">
              Let&apos;s Build Together <span>→</span>
            </a>
          </div>
        </div>
      </section>

      <ServicesSection />
      <SoftwareSection />
      <ProcessSection />
      <FutureSection />
      <StackSection />
      <PlatformSection />
      <FormSection />
      <DoubtsSection />
      <ClientSection />
      <Pagefooter />
    </>
  );
}

export default WebPage;